<template>
  <v-list-item-avatar>
    <v-progress-circular
      :value="getValue"
      :rotate="circularRotate"
      :color="$options.filters.colorByPercentage(getValue)"
    />
  </v-list-item-avatar>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      circularRotate: -90
    }
  },
  computed: {
    getValue () {
      return this.percentage
    }
  }
}
</script>
